import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = accountId => [
  {
    icon: 'mail-inbox',
    key: 'inboxView',
    label: 'INBOX_VIEW',
    featureFlag: FEATURE_FLAGS.INBOX_VIEW,
    toState: frontendURL(`accounts/${accountId}/inbox-view`),
    toStateName: 'inbox_view',
  },
  {
    icon: 'chat',
    key: 'conversations',
    label: 'CONVERSATIONS',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
  },
  // {
  //   icon: 'captain',
  //   key: 'captain',
  //   label: 'CAPTAIN',
  //   featureFlag: FEATURE_FLAGS.CAPTAIN,
  //   toState: frontendURL(`accounts/${accountId}/captain`),
  //   toStateName: 'captain',
  // },
  {
    icon: 'book-contacts',
    key: 'contacts',
    label: 'CONTACTS',
    featureFlag: FEATURE_FLAGS.CRM,
    toState: frontendURL(`accounts/${accountId}/contacts`),
    toStateName: 'contacts_dashboard',
  },
  {
    icon: 'arrow-trending-lines',
    key: 'reports',
    label: 'REPORTS',
    featureFlag: FEATURE_FLAGS.REPORTS,
    toState: frontendURL(`accounts/${accountId}/reports`),
    toStateName: 'account_overview_reports',
  },
  {
    icon: 'megaphone',
    key: 'campaigns',
    label: 'CAMPAIGNS',
    featureFlag: FEATURE_FLAGS.CAMPAIGNS,
    toState: frontendURL(`accounts/${accountId}/campaigns`),
    toStateName: 'ongoing_campaigns',
  },
  {
    icon: 'library',
    key: 'helpcenter',
    label: 'HELP_CENTER.TITLE',
    featureFlag: FEATURE_FLAGS.HELP_CENTER,
    alwaysVisibleOnChatwootInstances: true,
    toState: frontendURL(`accounts/${accountId}/portals`),
    toStateName: 'default_portal_articles',
  },
  // {
  //   icon: 'settings',
  //   key: 'settings',
  //   label: 'SETTINGS',
  //   toState: frontendURL(`accounts/${accountId}/settings`),
  //   toStateName: 'settings_home',
  // },
  {
    icon: 'book',
    key: 'knowledge',
    label: 'KNOWLEDGE',
    featureFlag: FEATURE_FLAGS.KNOWLEDGE,
    toState: frontendURL(`accounts/${accountId}/knowledge`),
    toStateName: 'knowledge',
  },
  {
    icon: 'google-sheet',
    key: 'google_sheet',
    label: 'GOOGLE_SHEET',
    featureFlag: FEATURE_FLAGS.GOOGLE_SHEET,
    toState: frontendURL(`accounts/${accountId}/google_sheet`),
    toStateName: 'google_sheet',
  },
  {
    icon: 'book-pulse',
    key: 'knowledge_improvement',
    label: 'KNOWLEDGE_IMPROVEMENT',
    featureFlag: FEATURE_FLAGS.KNOWLEDGE_IMPROVEMENT,
    toState: frontendURL(`accounts/${accountId}/knowledge_improvement`),
    toStateName: 'knowledge_improvement',
  },
  {
    icon: 'calendar',
    key: 'appointments',
    label: 'APPOINTMENTS',
    featureFlag: FEATURE_FLAGS.APPOINTMENTS,
    toState: frontendURL(`accounts/${accountId}/appointments`),
    toStateName: 'appointments',
  },
  // Real Estate's own Property Appointments — takes this nav slot when the
  // real_estate module is active (the entry above is hidden for those
  // accounts via AVAILABLE_MODULES.real_estate.disabledMenuItems).
  {
    icon: 'calendar',
    key: 'real_estate_appointments',
    label: 'REAL_ESTATE_APPOINTMENTS',
    toState: frontendURL(`accounts/${accountId}/real_estate/appointments`),
    toStateName: 'real_estate_appointments',
    moduleRestricted: 'real_estate',
  },
  // {
  //   icon: 'calendar-clock',
  //   key: 'appointments',
  //   label: 'APPOINTMENTS',
  //   toState: frontendURL(`accounts/${accountId}/v3/appointments`),
  //   toStateName: 'appointments.v3',
  // },
  // Conditional: hidden for accounts using organization instead (see
  // hasOrganizationAccess handling in Sidebar.vue)
  {
    icon: 'building-bank',
    key: 'branches',
    label: 'BRANCHES',
    featureFlag: FEATURE_FLAGS.BRANCHES,
    toState: frontendURL(`accounts/${accountId}/branches`),
    toStateName: 'branches',
  },
  // Conditional: shown only for accounts using organization instead of the
  // legacy branch feature (see hasOrganizationAccess handling in Sidebar.vue)
  {
    icon: 'organization',
    key: 'organization',
    label: 'ORGANIZATION',
    toState: frontendURL(`accounts/${accountId}/organization`),
    toStateName: 'organization',
  },
  {
    icon: 'condo',
    key: 'real_estate',
    label: 'REAL_ESTATE',
    toState: frontendURL(`accounts/${accountId}/real_estate`),
    toStateName: 'real_estate',
    moduleRestricted: 'real_estate',
    // Property Appointments has its own nav slot/icon (key: 'real_estate_appointments')
    // even though its route is nested under /real_estate, so it shouldn't also
    // light up this entry via router-link's prefix-match isActive.
    inactiveOnRoutes: ['real_estate_appointments'],
  },
  {
    icon: 'condo',
    key: 'real_estate',
    label: 'REAL_ESTATE',
    toState: frontendURL(`accounts/${accountId}/real_estate`),
    toStateName: 'real_estate',
    moduleRestricted: 'real_estate',
    // Property Appointments has its own nav slot/icon (key: 'real_estate_appointments')
    // even though its route is nested under /real_estate, so it shouldn't also
    // light up this entry via router-link's prefix-match isActive.
    inactiveOnRoutes: ['real_estate_appointments'],
  },
  {
    icon: 'condo',
    key: 'co_living',
    label: 'CO_LIVING',
    toState: frontendURL(`accounts/${accountId}/co_living`),
    toStateName: 'co_living',
    moduleRestricted: 'co_living',
  },
  {
    icon: 'ticket',
    key: 'co_living_tickets',
    label: 'CO_LIVING_TICKETS',
    toState: frontendURL(`accounts/${accountId}/co_living_tickets`),
    toStateName: 'co_living_tickets',
    moduleRestricted: 'co_living',
  },
  {
    icon: 'briefcase',
    key: 'rental_branches',
    label: 'RENTAL_BRANCHES',
    featureFlag: FEATURE_FLAGS.RENTAL_BRANCHES,
    toState: frontendURL(`accounts/${accountId}/rental_branches`),
    toStateName: 'rental_branches',
  },
  {
    icon: 'document-list-clock',
    key: 'rental_bookings',
    label: 'RENTAL_BOOKINGS',
    featureFlag: FEATURE_FLAGS.RENTAL_BOOKINGS,
    toState: frontendURL(`accounts/${accountId}/rental_bookings`),
    toStateName: 'rental_bookings',
  },
  {
    icon: 'document',
    key: 'whitelist',
    label: 'WHITELIST',
    featureFlag: FEATURE_FLAGS.WHITELIST,
    toState: frontendURL(`accounts/${accountId}/whitelist`),
    toStateName: 'whitelist',
  },
  {
    icon: 'condo',
    key: 'condo_management',
    label: 'CONDO_MANAGEMENT',
    featureFlag: FEATURE_FLAGS.CONDO_MANAGEMENT,
    toState: frontendURL(`accounts/${accountId}/condo_management`),
    toStateName: 'condo_management',
    moduleRequired: 'condo_management',
  },
  {
    icon: 'ticket',
    key: 'eVoucher',
    label: 'E_VOUCHER',
    toState: frontendURL(`accounts/${accountId}/eVoucher`),
    toStateName: 'eVoucher',
    accountRestriction: { include: ['276'] }, // Show only for account 276
  },
  {
    icon: 'task',
    key: 'onboarding',
    label: 'ONBOARDING',
    toState: frontendURL(`accounts/${accountId}/onboarding`),
    toStateName: 'onboarding',
  },
  {
    icon: 'gift',
    key: 'mantap',
    label: 'MANTAP',
    featureFlag: FEATURE_FLAGS.CONDO_MANAGEMENT,
    toState: frontendURL(`accounts/${accountId}/mantap`),
    toStateName: 'mantap',
  },
];

export default primaryMenuItems;
